$(document).ready(function () {
  $('.image-text-with-icon--carousels').flickity({
    wrapAround: true,
    prevNextButtons: false,
    watchCSS: true
  });

  $('.portofolio--carousels').flickity({
    wrapAround: true,
    prevNextButtons: false,
    watchCSS: true
  });

  $('.teams--carousels').flickity({
    wrapAround: true,
    prevNextButtons: false,
    watchCSS: true
  });

  // Handle window resize
  let lw = $(window).width(); 
  $(window).on('resize', function() {
      const nw = $(window).width(); 
      if (nw !== lw) {
          if($('.investment-framework--block-items').length > 0){
            setInvestmentBlockHeight();
          }
          setPortfolioBlockHeight();
          setTextBlockHeight();
          lw = nw; 
      }
  });


  $('.investment-portofolio-block--title-wrapper').on('click', function () {
    const parent = $(this).parent();
    $('.investment-portofolio--block').not(parent).removeClass('open');
    $('.investment-portofolio--block').not(parent).each(function(){
      $(this).find('.accordion-wrapper').height(0);
    });

    parent.toggleClass('open');
    if(parent.hasClass('open')){
      const height = parent.find('.investment-portofolio-block--content-wrapper').outerHeight();
      parent.find('.accordion-wrapper').height(height);
    }else{
      parent.find('.accordion-wrapper').height(0);
    }
  });

  function setPortfolioBlockHeight(){
    if($('.investment-portofolio--block').length > 0){
      $('.investment-portofolio--block').each(function(){
        if($(window).width() > 880){
          $(this).find('.accordion-wrapper').removeAttr('style');
        }else{
          if($(this).hasClass('open')){
            const height = $(this).find('.investment-portofolio-block--content-wrapper').outerHeight();
            $(this).find('.accordion-wrapper').height(height);
          }else{
            $(this).find('.accordion-wrapper').height(0);
          }
        }
      });
    }
  }
  setPortfolioBlockHeight();


  $('.text-blocks-block--title-wrapper').on('click', function () {
    const parent = $(this).parent();
    $('.text-blocks--block').not(parent).removeClass('open');
    $('.text-blocks--block').not(parent).each(function(){
      $(this).find('.text-blocks-block--content-wrapper').height(0);
    });

    parent.toggleClass('open');
    if(parent.hasClass('open')){
      const height = parent.find('.text-blocks-block--content-text-wrapper').outerHeight();
      parent.find('.text-blocks-block--content-wrapper').height(height);
    }else{
      parent.find('.text-blocks-block--content-wrapper').height(0);
    }
  });

  function setTextBlockHeight(){
    if($('.text-blocks--block').length > 0){
      $('.text-blocks--block').each(function(){
        if($(window).width() > 880){
          $(this).find('.text-blocks-block--content-wrapper').removeAttr('style');
        }else{
          if($(this).hasClass('open')){
            const height = $(this).find('.text-blocks-block--content-text-wrapper').outerHeight();
            $(this).find('.text-blocks-block--content-wrapper').height(height);
          }else{
            $(this).find('.text-blocks-block--content-wrapper').height(0);
          }
        }
      });
    }
  }
  setTextBlockHeight();
  $('.teams--block-image-wrapper').on('click', function(){
    $(this).parent().find('.teams--more').trigger('click');
  })
  $('.teams--more').on('click', function () {
    $('body').addClass('overflow-hidden');
    const data = $(this).data('block');

    const drawer = $('.drawer--team');

    $('.drawer--team--image-wrapper img').attr('src', data.image);
    $('.drawer--team-name-wrapper h5').text(data.name);
    $('.drawer--team-name-wrapper a').attr('href', data.linkedin);
    $('.drawer--team-position').text(data.position);

    const tags = data.tags.split(', ');
    if (tags.length > 0) {
      $('.drawer--team-tags').empty();
      tags.forEach(tag => {
        $('.drawer--team-tags').append(`<div class='tag'>${tag}</div>`);
      });
    }

    $('.drawer--team-description').html(data.description);

    drawer.toggleClass('open');
  });

  $('.icon-close-wrapper,.drawer-overlay').on('click', function () {
    $('.drawer--team').toggleClass('open');
    $('body').removeClass('overflow-hidden');
  });



  // Get the target section element
  const $targetSection = $('.investment-portofolio');
  const $triggers = $('.investment-portofolio--triggers-wrapper');

  let currentIndex = 0;

  // Add a scroll event listener to the window
  $(window).scroll(function() {
    // Get the current scroll position
    const scrollPosition = $(window).scrollTop();

    // Get the position of the target section
    const sectionPosition = $targetSection.offset().top - 100; // 100 is buffer

    // Check if the scroll position has reached the target section
    if (scrollPosition >= sectionPosition) {
      if($(window).width() > 880){
        startTimer();
      }
    }



    let activeLink = null;
    $(".list-menu a").each(function () {
      const href = $(this).attr("href");
      const section = $(href);

      if (section.length) {
        const sectionTop = section.offset().top - 100;
        if (scrollPosition >= sectionTop) {
          activeLink = $(this); // Mark this link as active
        }
      }
    });

    // Remove the class from all links
      $(".list-menu a").removeClass("button--primary-2");

      // Add the class to the latest matching link
      if (activeLink) {
        activeLink.addClass("button--primary-2");
      }else{
        $(".list-menu li:last-child a").addClass("button--primary-2");
      }

    
  });

  $triggers.on('click', function() {
    currentIndex = $(this).index();
    resetTimer();
  });
  

  const duration = 10;
  let timer = 0;
  let lastTimestamp = performance.now();
  let isTimerActive = false;

  function startTimer() {
    if($(window).width() < 881){
      stopTimer();
    }
    if (!isTimerActive) {
      isTimerActive = true;
      requestAnimationFrame(updateTimer);

      // Activate the current .investment-portofolio--triggers-wrapper
      $triggers.removeClass('active');
      $triggers.eq(currentIndex).addClass('active');
      $('.investment-portofolio--block').removeClass('open');
      $('.investment-portofolio--block').eq(currentIndex).addClass('open');
    }
  }

  function updateTimer(timestamp) {
    const elapsedTime = timestamp - lastTimestamp;
    lastTimestamp = timestamp;

    timer += elapsedTime / 1000;
    updateProgress();

    if (timer >= duration) {
      currentIndex = (currentIndex + 1) % $triggers.length;
      resetTimer();
    } else {
      requestAnimationFrame(updateTimer);
    }
  }

  function updateProgress() {
    const progress = timer / duration;
    $triggers.eq(currentIndex).find('.investment-portofolio--triggers-progress').css("transform", `scaleX(${progress})`);
  }

  function resetTimer() {
    timer = 0;
    lastTimestamp = performance.now();
    isTimerActive = false;
    $triggers.eq(currentIndex).find('.investment-portofolio--triggers-progress').css("transform", "scaleX(0)");
    
    startTimer();
  }

  function stopTimer(){
    isTimerActive = false;
    $triggers.eq(currentIndex).find('.investment-portofolio--triggers-progress').css("transform", "scaleX(0)");
  }

  if($(window).width() < 881){
    stopTimer();
  }





  function adjustSlideFramework($parent, currentIndex) {
    if ($(window).width() <= 880) {
      $parent.find('.investment-framework--item').first().css('margin-left', `calc(-${currentIndex}*80%)`);
    }
  }

  if($('.investment-framework--block-items.mobile-block').length){
    $('.investment-framework--block-items.mobile-block').each(function(){
      const sliderEl = $(this);
      $(this).flickity({
        wrapAround: false,
        prevNextButtons: false,
        cellAlign: 'left',
        contain: true,
        on: {
          change: function (index) {
            const parentEl = sliderEl.parents('.investment-framework--block');
            const blockSlider = parentEl.find('.investment-framework--block-items.mobile-block');
            const currentIndex = index;
            const totalItems = blockSlider.find('.investment-framework--item').length;
            const $navigation = parentEl.find('.investment-framework--block-navigation');
            $navigation.find('.next').toggleClass('disabled', currentIndex >= totalItems - 1);
            $navigation.find('.prev').toggleClass('disabled', currentIndex <= 0);
          }
        }
      });
    });
  }

  $('.investment-framework--block-navigation .prev').on('click', function () {
    const isMobile = $(window).width() < 881;
    const parentEl = $(this).closest('.investment-framework--block');
    const blockSlider = parentEl.find(
      `.investment-framework--block-items.${isMobile ? 'mobile-block' : 'desktop-block'}`
    );
  
    $(this).closest('.investment-framework--block-navigation').find('.next').removeClass('disabled');
  
    const currentIndex = parseInt(blockSlider.data('current-index')) || 0;
    const prevIndex = currentIndex - 1;
  
    if (prevIndex >= 0) {
      blockSlider.data('current-index', prevIndex);
  
      if (isMobile) {
        blockSlider.flickity('previous');
      } else {
        adjustSlideFramework(blockSlider, prevIndex);
        blockSlider.find('.investment-framework--item').removeClass('active')
          .eq(prevIndex).addClass('active');
      }
    }
  
    if (prevIndex <= 0) {
      $(this).addClass('disabled');
    }
  });

  $('.investment-framework--block-navigation .next').on('click', function () {
    const isMobile = $(window).width() < 881;
    const parentEl = $(this).closest('.investment-framework--block');
    const blockSlider = parentEl.find(
      `.investment-framework--block-items.${isMobile ? 'mobile-block' : 'desktop-block'}`
    );
  
    $(this).closest('.investment-framework--block-navigation').find('.prev').removeClass('disabled');
  
    const currentIndex = parseInt(blockSlider.data('current-index')) || 0;
    const nextIndex = currentIndex + 1;
    const totalItems = blockSlider.find('.investment-framework--item').length;
  
    if (nextIndex < totalItems) {
      blockSlider.data('current-index', nextIndex);
  
      if (isMobile) {
        blockSlider.flickity('next');
      } else {
        adjustSlideFramework(blockSlider, nextIndex);
        blockSlider.find('.investment-framework--item').removeClass('active')
          .eq(nextIndex).addClass('active');
      }
    }
  
    if (nextIndex >= totalItems - 1) {
      $(this).addClass('disabled');
    }
  });
  

  $('.investment-framework-item--title-wrapper').on('click', function () {
    if($(window).width() < 881){
      return;
    }
    const $block = $(this).closest('.investment-framework--block');
    const $item = $(this).closest('.investment-framework--item');
    const $navigation = $block.find('.investment-framework--block-navigation');
    const $items = $block.find('.investment-framework--item');

    const index = $item.index();
    const nextIndex = index + 1;
    const prevIndex = index - 1;

    // Update current index
    $block.data('current-index', index);

    // Adjust the slide framework
    adjustSlideFramework($block, index);

    // Update active class
    $items.removeClass('active');
    $item.addClass('active');

    // Update navigation buttons
    $navigation.find('.next').toggleClass('disabled', nextIndex >= $items.length);
    $navigation.find('.prev').toggleClass('disabled', prevIndex < 0);
  });

  function setInvestmentBlockHeight(){
    if($(window).width() < 881){
      return;
    }
    $('.investment-framework--block-items').each(function(){
      const blocks = $(this).find('.investment-framework--item');
      let maxHeight = 0;
      blocks.each(function(){
        const headingHeight = $(this).find('.investment-framework-item--title-wrapper').outerHeight();
        const bodyHeight = $(this).find('.investment-framework-item--content-wrapper').outerHeight();
        const totalHeight = headingHeight + bodyHeight + 10;
        if(totalHeight > maxHeight){
          maxHeight = totalHeight;
        }
      });
      blocks.height(maxHeight);

    });
  }
  if($('.investment-framework--block-items').length > 0){
    setInvestmentBlockHeight();
  }

  
  let ticking = false; // Prevent redundant execution
    const parallaxSpeed = 0.3; // Adjust speed as needed

    // Create an IntersectionObserver for better viewport checking
    const parallaxObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            applyParallax(entry.target);
          }
        });
      },
      {
        threshold: 0, // Trigger as soon as the element enters the viewport
      }
    );

    // Attach observer to all parallax elements
    const parallaxElements = document.querySelectorAll('.parallax-bg');
    parallaxElements.forEach((element) => {
      parallaxObserver.observe(element);
    });

    // Scroll event listener with requestAnimationFrame for smooth updates
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(() => {
          parallaxElements.forEach((element) => {
            applyParallax(element);
          });
          ticking = false;
        });
        ticking = true;
      }
    });

    function applyParallax(element) {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const offsetTop = element.getBoundingClientRect().top + scrollTop;
      const elementHeight = element.offsetHeight;

      // Check if the element is in the viewport
      if (scrollTop + windowHeight > offsetTop && scrollTop < offsetTop + elementHeight) {
        const parallaxOffset = (scrollTop - offsetTop) * parallaxSpeed;
        element.style.transform = `translate3d(0, ${parallaxOffset}px, 0)`; // GPU-optimized
      }
    }


  var numbers = document.querySelectorAll('.track-record--content_block h2 span.number');
  numbers.forEach(function (el) {
    el.setAttribute('data-value', el.textContent);
    const val = '0'.repeat(el.textContent.length);

    od = new Odometer({
      el: el,
      value: val,
      format: '',
      theme: 'default',
      duration: 1000,
    });
  });

  function animateNumbers() {
    numbers.forEach(function (el) {
      const shopifySection = $(el).parents('.shopify-section');
      if(window.scrollY > shopifySection.offset().top - window.innerHeight / 2){
        const value = el.getAttribute('data-value');
        el.textContent = value;
      }
    });
  }
  animateNumbers();
  $(window).on('scroll', function() {
    animateNumbers();
  });

  $(document).on('click','.portofolio--block', function(e){
    const link = $(this).find('a.link');
    console.log($(e.target).parents('.portofolio--block-social-wrapper'));
    if(!$(e.target).parents('.portofolio--block-social-wrapper').length){
      window.open(link.attr('href'), '_blank');
    }
  });





});


$(document).on('click', '.menu-drawer__menu-item, .header__menu-item', function(e) {
  e.preventDefault();
  const target = $(this).attr('href');
  const targetElement = $(`${target}`);
  if (targetElement.length) {
    if($(window).width() <= 880){
      $('.header__icon--menu').trigger('click');
    }
    $('html, body').animate({
      scrollTop: targetElement.offset().top - $('header').outerHeight()
    }, 500);
  }
});

$(document).on('click', '.hero .button--primary', function(e) {
  e.preventDefault();
  const target = $(this).attr('href');
  const targetElement = $(`${target}`);
  if (targetElement.length) {
    $('html, body').animate({
      scrollTop: targetElement.offset().top - $('header').outerHeight()
    }, 500);
  }
});

// Text Over Image - Random Icon Blink
$(document).ready(function() {
  function scaleIconWrapper(sectionId) {
    const wrapper = $(`#TextOverImage-${sectionId} .icon-random-wrapper`);
    if (!wrapper) return; // Exit if the element is not found

    const viewportWidth = window.innerWidth;
    const scale = Math.min(viewportWidth / 600, 1); // Limit the scale to a maximum of 1
    wrapper.css('transform',`scale(${scale.toFixed(2)})`)
  }
  function initIconBlink(sectionId) {
    const $wrapper = $(`#TextOverImage-${sectionId} .icon-random-wrapper`);
    const $icons = $wrapper.find('svg');
    let currentIndex = 0;
    scaleIconWrapper(sectionId);
    function getNextIndex(currentIndex) {
      // Move 1-3 steps forward
      const nextIndex = currentIndex + 1;
      
      // If we've reached the end, reset to start
      return nextIndex >= $icons.length ? 0 : nextIndex;
    }

    function blinkIcon() {
      // Reset all icons to visible
      $icons.css('opacity', 1);
      
      // Blink only the current icon
      $icons.eq(currentIndex).css('opacity', 0);
      
      setTimeout(() => {
        $icons.eq(currentIndex).css('opacity', 1);
        
        // Get and set next index
        currentIndex = getNextIndex(currentIndex);
      }, 500);
    }

    // Start the blinking sequence
    setInterval(blinkIcon, 600);
  }

  // Initialize for each Text Over Image section on the page
  $('[id^="TextOverImage-"]').each(function() {
    const sectionId = $(this).attr('id').replace('TextOverImage-', '');
    initIconBlink(sectionId);
    $(window).on('resize', function() {
      const nw = $(window).width(); 
      if (nw !== lw) {
        scaleIconWrapper(sectionId);
          lw = nw; 
      }
    });
  });

  $('#menu-drawer .button-action a').on('click', function(){
    const href = $(this).attr('href');
    const section = $(href);
    if(section){
      $('html, body').animate({
        scrollTop: section.offset().top - $('header').outerHeight()
      }, 500);
    }
    
    $('.header__icon--summary').trigger('click');
  })




});